var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "el-row-line" },
        [
          _c("PageInfo"),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticStyle: { float: "right" },
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.addBranchBtn()
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-plus" }),
              _vm._v("\n      添加部门"),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [_c("el-col", [_c("el-form", { attrs: { inline: true } })], 1)],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%", "margin-bottom": "20px" },
              attrs: {
                stripe: "",
                data: _vm.listData,
                "row-key": "id",
                border: "",
                "tree-props": {
                  children: "children",
                  hasChildren: "hasChildren",
                },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "name", label: "部门", width: "780" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.name
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  plain: "",
                                  type:
                                    scope.row.state === 1 ? "primary" : "info",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.tableEdit(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(scope.row.name) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(scope.row.user, function (item, index) {
                          return _c("el-button", { key: index }, [
                            _vm._v(_vm._s(item.real_name)),
                          ])
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "state", label: "状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type:
                                scope.row.state === 1 ? "primary" : "danger",
                              "disable-transitions": "",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(scope.row.state === 1 ? "正常" : "禁用")
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { prop: "des", label: "描述" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.addBranchBtn(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("添加部门")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "danger" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteBranchBtn(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            "close-on-press-escape": !1,
            "close-on-click-modal": !1,
            title: _vm.isEdit ? "编辑部门" : "新增部门",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "branchForm",
              attrs: {
                rules: _vm.rules,
                model: _vm.dataForm,
                "label-width": "90px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "pid", label: "pid" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.dataForm.pid,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "pid", $$v)
                      },
                      expression: "dataForm.pid",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "name", label: "名称" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.dataForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "name", $$v)
                      },
                      expression: "dataForm.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "user", label: "用户" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { multiple: "", clearable: "", filterable: "" },
                      model: {
                        value: _vm.dataForm.user,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataForm, "user", $$v)
                        },
                        expression: "dataForm.user",
                      },
                    },
                    _vm._l(_vm.userList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { value: item.id, label: item.real_name },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "状态", prop: "state" } },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-value": 1,
                      "inactive-value": 0,
                      "active-text": "启用",
                      "inactive-text": "禁用",
                    },
                    model: {
                      value: _vm.dataForm.state,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "state", $$v)
                      },
                      expression: "dataForm.state",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-divider"),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-error" },
                  on: { click: _vm.resetForm },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-success" },
                  on: { click: _vm.onSave },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }